<script>
export default {
    name: "RenalQueue",

}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <h5 class="font-semibold">Renal Queue</h5>
              </template>
              <template v-slot:card-body>
                  <div class="flex flex-wrap my-2 bg-gray-400">
                      <div class="md:w-1/6 sm:w-1/4 p-1">
                            <router-link 
                                class="btn-sm text-xs btn-info rounded" 
                                to=""><i class="fa fa-syringe"></i> Open Medical File
                            </router-link>
                      </div>
                  </div>
                  <div class="w-full overflow-auto max-h-screen">
                        <div class="w-full flex flex-wrap">
                            <div class="md:w-1/4 sm:w-1/2 p-tiny">
                                <input type="text" class="input-sm input-control text-sm" placeholder="Search">
                            </div>
                            <div class="md:w-1/4 sm:w-1/3 p-tiny">
                                <button 
                                    class="btn-sm btn-primary text-xs rounded">
                                        <i class="fa fa-search"></i> Filter</button>
                            </div>
                        </div>
                        <table class="w-full table table-hover">
                            <thead class="bg-indigo-400 text-sm">
                                <tr class="flex text-white w-full">
                                    <th class="p-tiny w-1/3">Patient</th>
                                    <th class="p-tiny w-1/6">IP NO</th>
                                    <th class="p-tiny w-1/6">OP NO</th>
                                    <th class="p-tiny w-1/6">Mobile</th>
                                    <th class="p-tiny w-1/6">Inpatient</th>
                                    <th class="p-tiny w-1/12">Visits</th>
                                    <th class="p-tiny w-1/12">Select</th>
                                </tr>
                            </thead>
                            <tbody class="text-xs font-semibold bg-gray-100 flex flex-col items-center overflow-auto w-full" style="height: 60vh;">
                                <tr class="flex w-full">
                                    <td class="p-tiny w-1/3">
                                        <h5 class="text-sm text-gray-900">Patient Names</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">MRN:</h5>
                                        <h5 class="text-xs leading-5 text-gray-700">DOB: </h5>
                                        <h5 class="text-xs leading-5 text-gray-700">Gender:</h5>
                                    </td>
                                    <td class="p-tiny w-1/6"></td>
                                    <td class="p-tiny w-1/6"></td>
                                    <td class="p-tiny w-1/6"></td>
                                    <td class="p-tiny w-1/6"></td>
                                    <td class="p-tiny w-1/12"></td>
                                    <td class="p-tiny w-1/12"></td>
                                </tr>
                            </tbody>
                        </table>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>